module.exports = __webpack_public_path__ + "static/media/2022.d6ede458.webp";